import React from "react";
import { Controller } from "react-hook-form";
import FormControl from '@material-ui/core/FormControl';
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from '@material-ui/core/MenuItem';
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
const generateSelect = (schema = []) => schema.map((item, index) => {
    const { value, label } = item;
    return (<MenuItem value={value} key={index}>{label}</MenuItem>);
});
export default function HookFormSelect(props) {
    const { error, selectSchema, control, name, label, rules, defaultValue = "", direction, disableUnderline = false, controllerProps, selectProps, helperText, onChange: handleChange } = props;
    const onChange = (e) => {
        const event = e[0];
        handleChange && handleChange(event);
        const { value } = event.target;
        return value;
    };
    const margin = direction === "column" ? "16px" : "0px";
    return (<>
      <FormControl style={{ width: "100%", marginTop: margin, minWidth: "100px" }} margin="none" error={error} fullWidth>
        {label && <InputLabel id="select-label" required={rules && !!rules.required}>
          {label}
        </InputLabel>}
        <Controller as={<Select disableUnderline={disableUnderline} {...selectProps} MenuProps={{
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
        }
    }}>
              {generateSelect(selectSchema)}
            </Select>} name={name} rules={rules} control={control} defaultValue={defaultValue} onChange={onChange} {...controllerProps}/>
        {helperText && <FormHelperText>
          {helperText}
        </FormHelperText>}
      </FormControl>
    </>);
}
